import React from 'react';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { strings } from '/imports/strings';
import { useUser } from '/imports/hooks';
import { Icon } from '/imports/ui/Icon';

export const NotPermittedPage = () => {
  const user = useUser();
  const navigate = useNavigate();
  if (!user) navigate('/login');
  return (
    <div className="page flex h-full w-full flex-col justify-around text-center">
      <div className="wrapper m-auto">
        <Icon icon="block" />
        <h2>{strings.YouAreNotPermitted()}</h2>
        <p className="text-center text-[1.1rem]"><Link to="/">{strings.GoToHomePage()}</Link></p>
      </div>
    </div>
  );
};